/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="6.89"
        height="19"
        viewBox="0 0 6.89 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 19h6.88l-3-2.74v-2.55l1-1.13a3.22 3.22 0 0 0 .84-2.17V0H.96v10.5a2.86 2.86 0 0 0 .78 2l1.1 1.19v2.53ZM2.05 1h2.76v5.75H2.05Zm.5 10.81a1.91 1.91 0 0 1-.5-1.28V7.75h2.76v2.66a2.23 2.23 0 0 1-.58 1.49l-.79.86Zm.85 5.33.93.86H2.5Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ChampagneFluteHalfFullIcon';

export default Icon;
